import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import DramaCard from '@/components/feature/DramaCard';
import { dramas } from '@/mocks/dramas';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntry from './components/CategoryEntry';
import DramaGridSection from './components/DramaGridSection';

export default function Home() {
  const featured = dramas.filter((d) => d.featured);
  const recommended = dramas.slice(0, 5);
  const latest = [...dramas]
    .sort((a, b) => (a.releaseDate < b.releaseDate ? 1 : -1))
    .slice(0, 4);

  useEffect(() => {
    document.title = '善良的小姨子在线播放 - 影视免费在线观看平台';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        'content',
        '善良的小姨子在线播放为您提供最新影视剧在线播放服务，涵盖剧情介绍及剧集更新，让您轻松观看各类影视内容。',
      );
    }
  }, []);

  return (
    <Layout>
      <HeroCarousel items={featured} />
      <CategoryEntry />

      <DramaGridSection
        title="推荐剧集"
        subtitle="甄选高分家庭情感与都市生活剧，陪你度过每个温暖夜晚"
        items={recommended}
        moreLink="/category"
      />

      <section className="w-full px-4 md:px-16 lg:px-24 py-12 md:py-16 bg-background-100">
        <div className="flex items-center gap-2 mb-2">
          <span className="w-1 h-5 rounded-full bg-secondary-500" />
          <span className="text-xs font-medium text-foreground-500 tracking-wide">更新动态</span>
        </div>
        <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl mb-6 md:mb-8">最新更新</h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-5">
          {latest.map((drama) => (
            <DramaCard key={drama.id} drama={drama} layout="horizontal" />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-16 lg:px-24 py-12 md:py-16">
        <div className="rounded-lg bg-primary-950 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <span className="inline-flex items-center gap-1.5 text-accent-400 text-xs font-medium mb-3">
                <i className="ri-heart-3-line" />
                关于本站
              </span>
              <h2 className="font-heading font-bold text-background-50 text-2xl md:text-3xl leading-snug">
                善良的小姨子在线播放
              </h2>
              <p className="text-background-100/75 text-sm md:text-base leading-relaxed mt-4 max-w-lg">
                我们专注于“善良的小姨子”及相关家庭情感、都市生活题材影视内容，提供清晰的剧集导航、详尽的剧情介绍与便捷的在线播放入口，让每一位观众都能轻松找到想看的温暖故事。
              </p>
              <div className="grid grid-cols-3 gap-4 mt-8 max-w-md">
                <div>
                  <p className="font-heading font-bold text-accent-400 text-2xl md:text-3xl">10+</p>
                  <p className="text-background-100/60 text-xs mt-1">精选剧集</p>
                </div>
                <div>
                  <p className="font-heading font-bold text-accent-400 text-2xl md:text-3xl">200+</p>
                  <p className="text-background-100/60 text-xs mt-1">剧集总集数</p>
                </div>
                <div>
                  <p className="font-heading font-bold text-accent-400 text-2xl md:text-3xl">24h</p>
                  <p className="text-background-100/60 text-xs mt-1">在线服务</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-3 mt-8">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-foreground-950 hover:bg-accent-600 transition-colors"
                >
                  了解我们
                  <i className="ri-arrow-right-line" />
                </Link>
                <Link
                  to="/category"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 hover:bg-background-50/10 transition-colors"
                >
                  <i className="ri-play-list-line" />
                  开始观看
                </Link>
              </div>
            </div>
            <div className="relative min-h-[260px] lg:min-h-full">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20of%20a%20happy%20family%20watching%20television%20together%20in%20a%20cozy%20living%20room%20at%20night%2C%20soft%20warm%20lamp%20glow%2C%20comfortable%20home%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20editorial%20cinematography&width=1200&height=900&seq=home-about-scene-01&orientation=landscape"
                alt="家庭一起观看影视的温馨场景"
                title="善良的小姨子在线播放 家庭观影"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}